import { IonButtons, IonPage } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { AuthContent } from "@/components/molecules/auth/content";
import { AuthHeader } from "@/components/molecules/auth/header";
import { AuthPageHeaderTitle } from "@/components/molecules/auth/page-header-title";
import { SignedQueryImage } from "@/components/molecules/signed-query-image";
import { SignInForm } from "@/form/sign-in.form";
import { queryOptions_signed_key_public_by_slug } from "@/lib/requests/file/file.get-signed-key";

export function AuthSignInPassword() {
  const { t } = useTranslation();
  const organizationSlug = import.meta.env.VITE_ORGANIZATION_SLUG;

  return (
    <IonPage>
      <AuthHeader>
        <IonButtons slot="primary"></IonButtons>
      </AuthHeader>
      <AuthContent>
        {organizationSlug && organizationSlug !== "boomer" ? (
          <SignedQueryImage
            width={75}
            height={75}
            alt="Organization Logo"
            {...queryOptions_signed_key_public_by_slug([
              "android-chrome-512x512.png",
              { slug: import.meta.env.VITE_ORGANIZATION_SLUG },
            ])}
          />
        ) : (
          <img width={50} height={50} src="/heyboomer.png" alt="heyboomer logo" className="mb-4" />
        )}
        <AuthPageHeaderTitle
          parts={{
            title: { children: t("page.auth.sign-in.title") },
          }}
        />
        <SignInForm />
      </AuthContent>
    </IonPage>
  );
}
